// src/app/views/pericia/listado-pericia/listado-pericia.component.ts
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { AppRoleDirective } from '@directives/appRoles/app-role.directive';
import { SharedModule } from '@modules/shared.module';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogParams } from '@interfaces/dialogParam.interface.model';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';
import { StatusBadgeComponent } from '@component/status-badge/status-badge.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { PericiaService } from '@services/pericia/pericia.service';
import { PericiaDto } from '@models/pericia/periciaDto.model';
import { PericiaFilter } from '@models/pericia/periciaFilter.model';
import { MatSelectModule } from '@angular/material/select';
import { ButtonActionComponent } from '@component/button-action/button-action.component';
import { BtnNuevoUsuarioComponent } from '@views/usuarios/btn-nuevo-usuario/btn-nuevo-usuario.component';
import { TipoPericiaService } from '@services/tipoPericia/tipoPericia.service';
import { EstadoPericiaService } from '@services/estadoPericia/estadoPericia.service';
import { DialogFormPericiaComponent } from '../dialog-form-pericia/dialog-form-pericia.component';
import { InputFilterTableComponent } from '@component/input-filter-table/input-filter-table.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgxSpinnerModule,
    AppRolesDirective,
    SinDatosParaMostrarComponent,
    BtnNuevoUsuarioComponent,
    MatCheckboxModule,
    MatSlideToggleModule,
    ButtonNewComponent,
    StatusBadgeComponent,
    ButtonActionComponent,
    MatTooltipModule,
    ButtonFilterTableClearComponent,
    ButtonFilterTableComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatTableModule,
    MatSelectModule,
    NgxSpinnerModule,
    InputFilterTableComponent
  ],
  selector: 'app-listado-pericia',
  templateUrl: 'listado-pericia.component.html',
  styleUrls: ['./listado-pericia.component.css'],
})
export class ListadoPericiaComponent implements OnInit {

  @Input() idExpediente!: number;
  @Input() showHeader: boolean = true;
  data = false;
  dataSource = new MatTableDataSource<PericiaDto>();
  displayedColumns: string[] = [];
  formFilter!: FormGroup;
  accionesDialog = AccionesDialog;

  // Catálogos para filtros
  tiposPericia: any[] = [];
  estadosPericia: any[] = [];

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

  private paginator!: MatPaginator;
  private sort!: MatSort;
  checkedFiltroAvanzado = false;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(
    public dialog: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private periciaService: PericiaService,
    private tipoPericiaService: TipoPericiaService,
    private estadoPericiaService: EstadoPericiaService,
    private formBuilder: FormBuilder
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'tipoPericia', 'accion'] :
        ['descripcion', 'tipoPericia', 'estadoPericia', 'lugar', 'fechaPropuesta', 'fechaRealizada', 'notificacionRealizada', 'accion'];
    });

    this.initializeForm();
  }

  ngOnInit() {
    this.loadCatalogs();
    this.cargarFiltroGuardado();
    this.aplicarFiltro();
  }

  initializeForm() {
    this.formFilter = this.formBuilder.group({
      Descripcion: [''],
      IdsTipoPericia: [[]],
      IdsEstadoPericia: [[]],
      Lugar: [''],
      Notificado: [''],
      FechaPropuestaDesde: [''],
      FechaPropuestaHasta: [''],
      FechaRealizadaDesde: [''],
      FechaRealizadaHasta: [''],
      FechaAltaDesde: [''],
      FechaAltaHasta: [''],
      FechaModificacionDesde: [''],
      FechaModificacionHasta: [''],
      FechaCedulaPresentacionDesde: [''],
      FechaCedulaPresentacionHasta: [''],
      FechaVencePresentacionDesde: [''],
      FechaVencePresentacionHasta: [''],
      FechaAceptaCargoDesde: [''],
      FechaAceptaCargoHasta: [''],
      FechaProponeDesde: [''],
      FechaProponeHasta: [''],
      FechaRealizaDesde: [''],
      FechaRealizaHasta: ['']
    });
  }

  loadCatalogs() {
    // Cargar tipos de pericia
    this.tipoPericiaService.getAll().subscribe({
      next: (tipos) => {
        this.tiposPericia = tipos;
      },
      error: (error) => {
        console.warn('Error al cargar tipos de pericia:', error);
      }
    });

    // Cargar estados de pericia
    this.estadoPericiaService.getAll().subscribe({
      next: (estados) => {
        this.estadosPericia = estados;
      },
      error: (error) => {
        console.warn('Error al cargar estados de pericia:', error);
      }
    });
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = data;
    dialogConfig.height = "85%";

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "80%";
        break;
      default:
        dialogConfig.width = "75%";
        break;
    }

    const dialogRef = this.dialog.open(DialogFormPericiaComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
        case AccionesDialog.Modificar:
        case AccionesDialog.Eliminar:
          this.aplicarFiltro();
          break;
        default:
          break;
      }
    });
  }

  sortingDataAccessor() {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'descripcion':
          return item.descripcion?.toLowerCase() || '';
        case 'tipoPericia':
          return item.tipoPericia?.descripcion?.toLowerCase() || '';
        case 'estadoPericia':
          return item.estadoPericia?.descripcion?.toLowerCase() || '';
        case 'lugar':
          return item.lugar?.toLowerCase() || '';
        case 'fechaPropuesta':
          return item.fechaPropuesta || '';
        case 'fechaRealizada':
          return item.fechaRealizada || '';
        case 'notificacionRealizada':
          return item.notificacionRealizada || false;
        default:
          return item[property];
      }
    };
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.sortingDataAccessor();
    this.iniciaFiltroTabla();
  }

  iniciaFiltroTabla() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const search = filter.trim().toLowerCase();
      return (
        data.descripcion?.toLowerCase().includes(search) ||
        data.tipoPericia?.descripcion?.toLowerCase().includes(search) ||
        data.estadoPericia?.descripcion?.toLowerCase().includes(search) ||
        data.lugar?.toLowerCase().includes(search) ||
        data.observaciones?.toLowerCase().includes(search) ||
        data.empresa?.descripcion?.toLowerCase().includes(search)
      );
    };
  }

  cargarFiltroGuardado() {
    const filtroGuardado = localStorage.getItem('filtroPericiaGuardado');
    if (filtroGuardado) {
      try {
        const filtro = JSON.parse(filtroGuardado);
        this.formFilter.patchValue(filtro);
      } catch (error) {
        console.warn('Error al cargar filtro guardado:', error);
      }
    }
  }

  guardarFiltro() {
    const filtro = this.formFilter.value;
    localStorage.setItem('filtroPericiaGuardado', JSON.stringify(filtro));
  }

  limpiarFiltro() {
    this.formFilter.reset();
    // Resetear arrays vacíos para selects múltiples
    this.formFilter.patchValue({
      IdsTipoPericia: [],
      IdsEstadoPericia: []
    });
    localStorage.removeItem('filtroPericiaGuardado');
    this.aplicarFiltro();
  }

  filtrosAvanzados(event: any) {
    this.checkedFiltroAvanzado = event.checked;
  }

  aplicarFiltro() {
    this.getAllByFilter();
    this.guardarFiltro();
  }

  getAllByFilter() {
    this.spinner.show("spPericias");

    // Crear el filtro
    const periciaFilter: PericiaFilter = new PericiaFilter();
    const formValue = this.formFilter.value;

    // Mapear valores del formulario al filtro
    periciaFilter.descripcion = formValue.Descripcion || null;
    periciaFilter.idExpediente = this.idExpediente || null;
    periciaFilter.idsTipoPericia = formValue.IdsTipoPericia?.length > 0 ? formValue.IdsTipoPericia : null;
    periciaFilter.idsEstadoPericia = formValue.IdsEstadoPericia?.length > 0 ? formValue.IdsEstadoPericia : null;
    periciaFilter.lugar = formValue.Lugar || null;
    periciaFilter.notificado = formValue.Notificado !== '' ? formValue.Notificado : null;

    // Fechas
    periciaFilter.fechaPropuestaDesde = formValue.FechaPropuestaDesde || null;
    periciaFilter.fechaPropuestaHasta = formValue.FechaPropuestaHasta || null;
    periciaFilter.fechaRealizadaDesde = formValue.FechaRealizadaDesde || null;
    periciaFilter.fechaRealizadaHasta = formValue.FechaRealizadaHasta || null;
    periciaFilter.fechaAltaDesde = formValue.FechaAltaDesde || null;
    periciaFilter.fechaAltaHasta = formValue.FechaAltaHasta || null;
    periciaFilter.fechaModificacionDesde = formValue.FechaModificacionDesde || null;
    periciaFilter.fechaModificacionHasta = formValue.FechaModificacionHasta || null;
    periciaFilter.fechaCedulaPresentacionDesde = formValue.FechaCedulaPresentacionDesde || null;
    periciaFilter.fechaCedulaPresentacionHasta = formValue.FechaCedulaPresentacionHasta || null;
    periciaFilter.fechaVencePresentacionDesde = formValue.FechaVencePresentacionDesde || null;
    periciaFilter.fechaVencePresentacionHasta = formValue.FechaVencePresentacionHasta || null;
    periciaFilter.fechaAceptaCargoDesde = formValue.FechaAceptaCargoDesde || null;
    periciaFilter.fechaAceptaCargoHasta = formValue.FechaAceptaCargoHasta || null;
    periciaFilter.fechaProponePericiaDesde = formValue.FechaProponeDesde || null;
    periciaFilter.fechaProponePericiaHasta = formValue.FechaProponeHasta || null;
    periciaFilter.fechaRealizaPericiaDesde = formValue.FechaRealizaDesde || null;
    periciaFilter.fechaRealizaPericiaHasta = formValue.FechaRealizaHasta || null;

    this.periciaService.getAllByFilter(periciaFilter)
      .subscribe({
        next: (data) => {
          this.spinner.hide("spPericias");
          this.dataSource.data = data;
          this.data = this.dataSource.data.length >= 1;
        },
        error: (error) => {
          this.spinner.hide("spPericias");
          this.snackBar.showError(error, "Error");
        }
      });
  }

  applyFilter(event: any) {
    if (event && event.target && event.target instanceof HTMLInputElement) {
      let filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  sendEmailNotification(idPericia: number) {
    this.spinner.show("spNotificacion");
    this.periciaService.sendEmailNotification(idPericia)
      .subscribe({
        next: () => {
          this.spinner.hide("spNotificacion");
          this.snackBar.showSuccess("Notificación enviada correctamente.", "Éxito");
          this.aplicarFiltro(); // Refrescar la lista
        },
        error: (error) => {
          this.spinner.hide("spNotificacion");
          this.snackBar.showError(error, "Error");
        }
      });
  }

  isFalsy(valor: any) {
    return isFalsy(valor);
  }

  trackByItems(index: number, item: any): any {
    return item?.id || index;
  }
}
